import { useDispatch } from 'react-redux';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { reduxAjaxMiddleware, reduxAjaxReducer, reduxAjaxReducerKey } from '@chipp972/redux-ajax';
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

import { fetchForRedux } from '../utils/apis/RestApi';
import { setCredentialsOnReduxRequest } from './middlewares/middlewares';
import { configReducer } from './configSlice';
import { i18nReducer } from './i18nSlice';
import { customerReducer } from './customerSlice';
import { catalogReducer } from './catalogSlice';
import { interventionReducer } from './interventionSlice';
import { userInfoReducer } from './userInfoSlice';
import { storeListReducer } from './store-list';
import { workshopInterventionReducer } from './workshopInterventionSlice';
import { appReducer } from './appSlice';
import { bookingReducer } from './bookingSlice';
import { pledgeDateTransform } from './transformers/intervention';
import { shippingReducer } from '../features/shipping/store/shippingSlice';
import { basketReducer } from './basketSlice';

const interventionPersistConfig = {
  key: 'intervention',
  storage: storageSession,
  transforms: [pledgeDateTransform],
};

const catalogPersistConfig = {
  key: 'catalog',
  storage: storageSession,
};

const basketPersistConfig = {
  key: 'basket',
  storage: storageSession,
};

const customerPersistConfig = {
  key: 'customer',
  storage: storageSession,
};

const bookingPersistConfig = {
  key: 'booking',
  storage: storageSession,
};

export const rootReducer = combineReducers({
  app: appReducer,
  configuration: configReducer,
  i18n: i18nReducer,
  customer: persistReducer(customerPersistConfig, customerReducer),
  catalog: persistReducer(catalogPersistConfig, catalogReducer),
  intervention: persistReducer(interventionPersistConfig, interventionReducer),
  workshopIntervention: workshopInterventionReducer,
  storeList: storeListReducer,
  userInfo: userInfoReducer,
  booking: persistReducer(bookingPersistConfig, bookingReducer),
  shipping: shippingReducer,
  basket: persistReducer(basketPersistConfig, basketReducer),
  [reduxAjaxReducerKey]: reduxAjaxReducer,
});

const store = configureStore({
  // @ts-expect-error types compatibility error from reduxAjaxMiddleware T type can't be assigned to unknown
  // Previous middleware was typed as any, but now it's typed as unknown
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false }).concat(reduxAjaxMiddleware({ fetchFn: fetchForRedux }), setCredentialsOnReduxRequest),
  reducer: rootReducer,
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;

type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export default store;
